import { Button } from "antd"
import { forwardRef } from "react"
import { useSelector } from "react-redux"
import { getTranslated } from "../../utils/CommonUtils"

const UMCButton = forwardRef(function UMCButton(props, ref) {
    const dict = useSelector(state => state.common.dict)

    return <Button
        {...props}
        ref={ref}
        type={props.type}
        style={props.customStyle}
        className={props.className}
        icon={props.icon && <>{props.icon}</>}
        size={props.size}
        onClick={()=>props.onClick && props.onClick()}
        danger={props.danger}
        ghost={props.ghost}
        disabled={props.disabled}
        title={getTranslated(dict, props.title)}
    >
        {getTranslated(dict, props.label) || props.children}
    </Button>
})

export default UMCButton